import { render, staticRenderFns } from "./render-group.vue?vue&type=template&id=0b6fc78d"
import script from "./render-group.vue?vue&type=script&lang=js"
export * from "./render-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports